// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"e_pf","pageSubTitle":"e_qf"};